
import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { Link, useNavigate } from "react-router-dom";

import { Icon } from 'semantic-ui-react'

import { toClassTimeListObject, sortByPlaceInWeek } from "../utils";

import { JoyyaHeader } from '../../../../components/JoyyaHeader';
import { ClassListItem } from "../../../../components/teacher/ClassListItem";

import { GET_CLASSES } from '../data/GET_CLASSES';
import { GET_MISSED_ATTENDANCE } from '../data/GET_MISSED_ATTENDANCE';

import styles from './TeacherClassesView.module.css'

import { Popup } from '../../../../components/teacher/AttendanceReminderPopup';

const CURRENT_BLOCK_TAG_ID = process.env.NODE_ENV === 'development' ? 'tagId:113' : 'tagId:1774'

const TeacherClassesView = () => {
    const navigate = useNavigate();
    const [isPopupVisible, setIsPopupVisible] = useState(true);

    const { data } = useQuery(GET_MISSED_ATTENDANCE);

    const { data: classesData } = useQuery(GET_CLASSES, {
        variables: { search: '', filters: CURRENT_BLOCK_TAG_ID }
    });

    useEffect(() => {
        if (data?.attendanceMissed?.length > 0) setIsPopupVisible(true);
    }, [data]);

    let classTimesList: any[] = [];
    if (classesData?.classes?.length > 0) {
        classTimesList = classesData.classes.reduce(toClassTimeListObject, []);
        classTimesList.sort(sortByPlaceInWeek);
    }

    return (
        <>
            <JoyyaHeader />
            <div className="mobile-frame">
                <div className={styles.pageHeader}>
                    <Icon
                        name="arrow left"
                        size="large"
                        className={styles.backBtn}
                        onClick={() => navigate(-1)}
                    />
                    <h2 className={styles.pageTitle}>Classes</h2>
                </div>

                {isPopupVisible && data?.attendanceMissed?.length > 0 && (
                    <Popup
                        message={`You have classes with missed attendance. Please update attendance for ${data.attendanceMissed[0].name}.`}
                        onClose={() => setIsPopupVisible(false)}
                        attendanceFormUrl={`/classes/${data.attendanceMissed[0].id}`}
                    />
                )}

                {classTimesList.map((item: any) => (
                    <Link
                        to={`/classes/${item.id}`}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                        key={`${item.id}_${item.time}`}
                    >
                        <ClassListItem
                            time={item.time}
                            program={item.program}
                            classLabel={item.classLabel}
                            level={item.level}
                            communityCode={item.communityCode}
                        />
                    </Link>
                ))}
            </div>
        </>
    );
}

export { TeacherClassesView }
